import { createComponent, ElementWithProps } from '@carvana/merch-components';

export const Container = createComponent('div', {
  className:
    'mx-auto grid max-w-full auto-cols-fr justify-items-center gap-24 -:mt-40'
});

export type LoadingProps = ElementWithProps<{
  isLoading?: boolean;
  isLongCard?: boolean;
}>;

export const ElementWithLoading = createComponent<LoadingProps>(
  'div',
  props => ({
    className: props.isLoading
      ? `
          after:absolute
          after:inset-0
          after:z-[1]
          after:bg-white
          after:opacity-90
          after:backdrop-blur
          after:content-['']
          after:supports-[backdrop-filter:blur(8px)]:bg-[initial]
          after:supports-[backdrop-filter:blur(8px)]:opacity-[initial]
        `
      : undefined
  })
);
